var React = require('react');

function Mountains (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#006aff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("path",{"d":"m46.27 30.9-25.88 44.83h51.77z","key":0}),React.createElement("path",{"d":"m71.78 75.73h18.25l-18.99-32.9-8.94 15.51","key":1}),React.createElement("path",{"d":"m30.14 58.68-9.15-15.85-18.99 32.9h18.53","key":2}),React.createElement("path",{"d":"m46.2 30.92v-28.92","key":3}),React.createElement("path",{"d":"m63.62 17.07h-17.42v-10.67h17.42l4.46 5.13z","key":4}),React.createElement("path",{"d":"m35.73 49.2 5.36 5.27 5.11-5.21 5.12 5.21 5.34-5.62","key":5})]));
}

Mountains.defaultProps = {"viewBox":"0 0 92.03 77.73"};

module.exports = Mountains;

Mountains.default = Mountains;
